const updates = [
  { date: '07-31', title: '庆余年3 第28集已更新上线', type: '更新' },
  { date: '07-31', title: '墨雨云间 全集整理完成，一键追看', type: '上新' },
  { date: '07-30', title: '背着善宰跑 大结局已上线，完整追完', type: '完结' },
  { date: '07-30', title: '玫瑰的故事 第32集更新，剧情高潮', type: '更新' },
  { date: '07-29', title: '本周新增 5 部最新韩剧全集资源', type: '上新' },
  { date: '07-28', title: '日剧专区新增 3 部口碑新作全集', type: '上新' },
  { date: '07-27', title: '长相思2 第24集更新，追剧进行中', type: '更新' },
  { date: '07-26', title: '美剧全集播放专区优化，加载更快', type: '优化' },
  { date: '07-25', title: '与凤行 全集点播通道开放，免费观看', type: '活动' },
];

const typeColors: Record<string, string> = {
  '更新': 'bg-primary-100 text-primary-700',
  '上新': 'bg-accent-100 text-accent-700',
  '完结': 'bg-secondary-100 text-secondary-700',
  '优化': 'bg-background-200 text-foreground-600',
  '活动': 'bg-accent-100 text-accent-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100 px-3 py-1 rounded-full mb-3">
              实时跟进
            </span>
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
              最新动态
            </h2>
            <p className="text-sm text-foreground-500 mt-2">天天影院内容更新与平台动态一览</p>
          </div>

          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300/60 hidden sm:block"></div>

            <div className="space-y-4">
              {updates.map((item, i) => (
                <div key={i} className="flex gap-4 sm:gap-6 items-start">
                  <div className="hidden sm:flex w-10 h-10 rounded-full bg-background-50 border-2 border-background-200 flex-shrink-0 items-center justify-center text-xs font-bold text-foreground-500">
                    {i + 1}
                  </div>
                  <div className="flex-1 bg-background-50 rounded-xl p-4 border border-background-200/70 min-w-0">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-1.5">
                      <span className="text-xs text-foreground-400 font-mono whitespace-nowrap">{item.date}</span>
                      <span className={`text-xs px-2 py-0.5 rounded-full font-medium w-fit whitespace-nowrap ${typeColors[item.type] || 'bg-background-200 text-foreground-600'}`}>
                        {item.type}
                      </span>
                    </div>
                    <p className="text-sm font-medium text-foreground-800 leading-relaxed">{item.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}